import { server } from "../utils/server"


const getApprovedListing = (userId , page , limit , membertype,fetchCompleted) =>{
    return server.get("/investor/listings/all", {
        params: {
            membertype: membertype , //"REGULAR",
            userId,
            page , 
            limit,
            fetchCompleted
          }
    })
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const getApprovedSelectListing = (userId) =>{
    return server.get("/investor/listings/all", {
        params: {
            membertype: "SELECT",
            userId
          }
    })
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

// const getApprovedSelectListing = () =>{
//     return server.post('/investor/listings/allselect', {membertype: "SELECT"})
//     .then((res)=>{
//         return res.data;
//     })
//     .catch((err)=>{
//         console.log(err);
//     });
// }

const getApprovedProject = (page , limit) =>{
    return server.get(`/investor/projects/get?page=${page}&limit=${limit}`)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const getListingById = (id,userId) =>{
    return server.get(`/investor/listings/${id}?userId=${userId}`,)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const getProjectById = (id)=>{
    return server.get(`/projects/get/${id}`)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}
const getListingByAssetId = (assetId)=>{
    return server.get(`/investor/listings/getListingName/${assetId}`)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}
const getDeveloperById = (id)=>{
    return server.post("developerAdmin/auth/byId",{developerId:id})
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const getAssetclassById = (id)=>{
    return server.get(`/realXAdmin/asset/getAssetById/${id}`) .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const getProjectByBluePrintId = (id) =>{
    return server.get(`projects/getProjectClassById/${id}`)
    .then(res=>{
        return res.data
    })
    .catch(err=>{
        return err?.response?.data || { success: false, message: "Network error" };
    })
} 

const getAssetTermsAndConditions = (id) =>{
    return server.get(`realXAdmin/assetClassTermsAndCondition/get/${id}`)
    .then(res=>{
        return res.data
    })
    .catch(err=>{
        return err?.response?.data || { success: false, message: "Network error" };
    })
}



const listingService ={
    getApprovedListing,
    getApprovedSelectListing,
    getListingById,
    getProjectById,
    getDeveloperById,
    getApprovedProject,
    getAssetclassById,
    getProjectByBluePrintId,
    getListingByAssetId,
    getAssetTermsAndConditions
}

export default listingService;